<template>
  <div class="container">
    招标
  </div>
</template>

<script>
export default {

}
</script>

